import React from 'react'
import '../../../css/vizmental-ide.scss'
import '../../../css/studentview.scss'

// The VizmentalIDE layout (what Python / Vizmental students get on /session/:id) as a
// slot-based shell, reproducing VizmentalIDE.jsx's DOM and classes pane for pane:
//
//   left  (450px)  Task Description  +  Test Cases
//   middle         code editor, with the 250px terminal pinned to its bottom
//   right (450px)  AI chat - omitted entirely when `chat` is null, as VizmentalIDE does
//                  when the AI pane is off
//
// Two callers fill the slots differently: the wizard's read-only preview passes static
// facsimiles; the student-layout Task and Unit Test tab passes the real, editable
// instructor components. The resizers are drawn but inert - panes keep VizmentalIDE's
// default widths.
//
// `terminalProps` (optional) is spread onto the terminal panel - the wizard's live preview
// uses it to mark that panel as a highlightable region (live/previewRegions.js).
const VizmentalShell = ({
  task,
  tests = null,
  editor,
  runControls,
  terminal,
  chat = null,
  leftWidth = 450,
  rightWidth = 450,
  terminalHeight = 250,
  className = '',
  terminalProps = null,
}) => (
  <div className={`vizmental-container sv-vizmental ${className}`}>
    <div className="vizmental-content">
      <div className="vizmental-left-panel" style={{ width: `${leftWidth}px` }}>
        <div className="panel-content">
          {task}
          {tests && (
            <>
              <div className="section-divider"></div>
              {tests}
            </>
          )}
        </div>
      </div>

      <div className="vizmental-resizer horizontal sv-inert-resizer" />

      <div className="vizmental-middle-panel">
        <div className="editor-container" style={{ paddingBottom: `${terminalHeight}px` }}>
          {editor}
        </div>
        <div {...terminalProps} className="terminal-panel" style={{ height: `${terminalHeight}px` }}>
          <div className="vizmental-resizer vertical sv-inert-resizer" />
          <div className="terminal-controls">
            <div className="controls-left">{runControls}</div>
          </div>
          <div className="terminal-output">
            <div className="output-content">{terminal}</div>
          </div>
        </div>
      </div>

      {chat && (
        <>
          <div className="vizmental-resizer horizontal sv-inert-resizer" />
          <div className="vizmental-right-panel" style={{ width: `${rightWidth}px` }}>
            {chat}
          </div>
        </>
      )}
    </div>
  </div>
)

export default VizmentalShell
